/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionCardProps,
  ActionsProps,
  Product,
  RightPanelTabs,
  RightPanelTabsConfiguration,
} from '@access-erp/common';
import { CardType, IRowNode } from '@access-erp/ui-components';
import { useMemo, useState } from 'react';

import { UserRole } from '@/config/roles.config';

type ActionButton = {
  config: ActionCardProps;
  isVisible: boolean;
};

interface UseRightPanelParams {
  selectedHeaderRows: IRowNode<any>[];
  userRole?: UserRole;
}

export const useRightPanel = ({ selectedHeaderRows, userRole }: UseRightPanelParams) => {
  const [isVisibleBulkUpdateModal, setIsVisibleBulkUpdateModal] = useState(false);

  const closeBulkUpdateModal = () => setIsVisibleBulkUpdateModal(false);

  const actionButtons = useMemo<ActionButton[]>(
    () => {
      return [
        {
          config: {
            text: 'Bulk Update Contracts',
            cardType: CardType.ACTION,
            product: Product.ContractsAndBilling,
            onClick: () => setIsVisibleBulkUpdateModal(true),
          },
          isVisible: userRole === UserRole.FULL_ACCESS,
        },
      ];
    },
    [selectedHeaderRows, userRole],
  );

  const actionsParams: ActionsProps = {
    actionCards: {
      actions: actionButtons.filter((el) => el.isVisible).map((el) => el.config),
    },
  };

  const tabsConfiguration = useMemo<RightPanelTabsConfiguration>(
    () => ({
      [RightPanelTabs.ACTIONS]: actionsParams,
    }),
    [selectedHeaderRows, userRole],
  );

  return {
    tabsConfiguration,
    isVisibleBulkUpdateModal,
    closeBulkUpdateModal,
  };
};
